<div class="ion-app frame">
  <importer-header class="mat-elevation-z8"></importer-header>
  <div
    class="container main"
    id="main-content">
    <router-outlet></router-outlet>
  </div>
</div>
<coin-translation-viewer-banner></coin-translation-viewer-banner>
